import { Injectable } from '@angular/core';
import { HttpProvider } from '../../providers/http/http';
import { APP_CONFIG } from '../../environment';
import { DocUploadRequest, SandboxVisaUploadRequest } from '../../model/api/doc-upload/doc-upload-request.entity.interface';
import { DocUploadResponse } from '../../model/api/doc-upload/doc-upload-response.entity.interface';
import { DocUploadRequestStatus } from '../../model/api/doc-upload/doc-upload-request-status.entity.interface';
import { LoginProvider } from '../../providers/myria/login-provider';
import { LoggerProvider } from '../../providers/logger/logger'



@Injectable()
export class DocUploadProvider {

  constructor(private httpProvider: HttpProvider,
              private loginProvider: LoginProvider) {}

  async uploadComplianceFile(request: DocUploadRequest) : Promise<DocUploadResponse> {    
    LoggerProvider.info(this, "Doc Upload uploadComplianceFile called");
    let response: DocUploadResponse = {value: null,result: null};
    return await this.httpProvider
    .post(`${APP_CONFIG.API_URL}api/FileManagement/UploadComplianceFile/`, request, (res) => {
      response.value = res.Value;
      response.result = res.Result;
      return response;
    });

  }

  async modifyUploadRequestStatus(request: DocUploadRequestStatus) : Promise<DocUploadResponse> {   
    LoggerProvider.info(this, "Doc Upload modifyUploadRequestStatus called");
    let response: DocUploadResponse = {value: null,result: null};
    return await this.httpProvider
    .post(`${APP_CONFIG.API_URL}api/DocUpload/${this.httpProvider.getAuthCustomerId()}/ModifyUploadRequestStatus/`, request, (res) => {
      response.value = res.Value;
      response.result = res.Result;
      return response;
    });
  }

    async uploadSandboxVisa(request: SandboxVisaUploadRequest) : Promise<DocUploadResponse> {    
    LoggerProvider.info(this, "Sandbox Visa Upload uploadSandboxVisa called");
    let response: DocUploadResponse = {value: null,result: null};
    return await this.httpProvider
    .post(`${APP_CONFIG.API_URL}api/DocUpload/${this.httpProvider.getAuthCustomerId()}/SendDocument/`, request, (res) => {
      response.value = res.Value;
      response.result = res.Result;
      return response;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/doc-upload/doc-upload.ts